<template>
  <div class="hero-slide">
    <div class="grid">
      <div class="col-7-12 sm-col-1-1 inside ptb-xxlg flex flex-column justify-space-between">
        <div data-swiper-parallax="-200">
          <UIHeadingType
            class="mb-sm title"
            :heading-type="headingType"
            :title="title"
          />

          <p
            v-if="subtitle"
            class="heading-4 mb-0"
          >
            {{ subtitle }}
          </p>
        </div>
        <div data-swiper-parallax="-10">
          <div
            class="mb-0 intro-text"
            v-html="intro"
          />
          <div class="btn-container">
            <UIContentblockButton
              class="btn btn-primary mt-xlg"
              :name="linkObject1?.name"
              :link="linkObject1?.link"
              :target="linkObject1?.target"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { HeroSlideContent, HeroSlideResolvedEvent } from '@/types/heroSlider'

  defineProps<{
    content: HeroSlideContent
    title: string
    headingType?: string
    subtitle: string
    intro: string
    linkObject1?: HeroSlideContent['linkObject1']
    event?: HeroSlideResolvedEvent
  }>()
</script>

<style scoped lang="scss">
  .hero-slide {
    position: relative;
    z-index: 2;
    flex: 1;
    display: flex;
    width: 100%;
    min-width: 0;
  }

  .inside {
    height: 100%;
    color: $white;
    flex-wrap: nowrap;

    .title {
      overflow-wrap: break-word;
      hyphens: auto;
      hyphenate-limit-chars: 8 4 4;
    }
  }
</style>
